<script lang="ts">
	export let datetime: string;
</script>

<time {datetime}>{new Date(datetime).toLocaleDateString()}</time>

<style lang="postcss">
	@reference "../../app.css";

	time {
		@apply text-text-muted text-xs;
	}
</style>
